import { useContext, useMemo } from 'react'
import ContentfulContext from './ContentfulContext'

const useContentful = () => {
  const content = useContext(ContentfulContext)
  return useMemo(() => content || {}, [content])
}

export default useContentful
